import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import AddCoworkersEmailInput from './AddCoworkersEmailInput';
import RoleChangeDropdown from '../../AddCoworkersModal/RoleChangeDropdown';
import './AddCoworkersInput.scss';
var AddCoworkersInput = /*#__PURE__*/function (_React$Component) {
  function AddCoworkersInput() {
    _classCallCheck(this, AddCoworkersInput);
    return _callSuper(this, AddCoworkersInput, arguments);
  }
  _inherits(AddCoworkersInput, _React$Component);
  return _createClass(AddCoworkersInput, [{
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.props.errors;
      return /*#__PURE__*/React.createElement("div", null, errors.map(function (errorMessage, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "mt-3 error-messages",
          key: "".concat(errorMessage[0]).concat(index)
        }, /*#__PURE__*/React.createElement("i", {
          className: "me-3 fas fa-exclamation-triangle"
        }), errorMessage);
      }));
    }
  }, {
    key: "renderEmailRoleInput",
    value: function renderEmailRoleInput() {
      var _this$props = this.props,
        emails = _this$props.emails,
        onChangeEmails = _this$props.onChangeEmails,
        invitableRoles = _this$props.invitableRoles,
        selectedRole = _this$props.selectedRole,
        onChangeSelectedRole = _this$props.onChangeSelectedRole;
      return /*#__PURE__*/React.createElement("table", {
        className: "email-role-input-table",
        width: "100%"
      }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
        className: "body-text-2 medium-weight pb-3",
        width: "64%"
      }, "Emails"), /*#__PURE__*/React.createElement("th", {
        className: "body-text-2 medium-weight pb-3",
        width: "36%"
      }, "Role")), /*#__PURE__*/React.createElement("tr", {
        className: "email-tags-and-roles-dropdown"
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AddCoworkersEmailInput, {
        emails: emails,
        handleChange: function handleChange(newEmails) {
          return onChangeEmails(newEmails);
        }
      })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
        className: "roles-dropdown"
      }, /*#__PURE__*/React.createElement(RoleChangeDropdown, {
        permissionOptions: invitableRoles,
        onChange: function onChange(newRole) {
          return onChangeSelectedRole(newRole);
        },
        value: selectedRole
      }))))));
    }
  }, {
    key: "renderMessageInput",
    value: function renderMessageInput() {
      var _this$props2 = this.props,
        message = _this$props2.message,
        placeholder = _this$props2.placeholder,
        onChangeMessage = _this$props2.onChangeMessage;
      return /*#__PURE__*/React.createElement("div", {
        className: "mb-3 mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "invitation-label mb-3"
      }, "Message", ' ', /*#__PURE__*/React.createElement("span", {
        className: "normal-weight"
      }, "(Optional)")), /*#__PURE__*/React.createElement("textarea", {
        className: "invitation-message-textarea",
        rows: "3",
        placeholder: placeholder,
        value: message,
        onChange: function onChange(event) {
          return onChangeMessage(event.target.value);
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        withMessage = _this$props3.withMessage,
        errors = _this$props3.errors;
      var hasErrors = errors && errors.length > 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "add-coworkers-input-container style-guide"
      }, this.renderEmailRoleInput(), hasErrors && this.renderErrors(), withMessage && this.renderMessageInput());
    }
  }]);
}(React.Component);
AddCoworkersInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChangeEmails: PropTypes.func.isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedRole: PropTypes.string.isRequired,
  onChangeSelectedRole: PropTypes.func.isRequired,
  withMessage: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  message: PropTypes.string,
  placeholder: PropTypes.string,
  onChangeMessage: PropTypes.func
};
AddCoworkersInput.defaultProps = {
  withMessage: true,
  errors: [],
  message: '',
  placeholder: 'Write a message here...',
  onChangeMessage: function onChangeMessage() {
    return null;
  }
};
export default AddCoworkersInput;